import { 
  baseApi, 
  select, 
  insert,
  update,
  remove
} from './base';

import {
  taskType
} from '../graphqlTypes';

const taskApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getTasks: select(builder, 'task', taskType),
    insertTask: insert(builder, 'task', taskType),
    deleteTask: remove(builder, 'task', taskType),
    updateTask: update(builder, 'task', taskType),
  }),
  overrideExisting: false,
});

export const { 
  useGetTasksQuery,
  useUpdateTaskMutation,
  useDeleteTaskMutation,
  useInsertTaskMutation,
} = taskApi